(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(scope) {
    scope.querySelectorAll('[data-rm-stock-urgency]').forEach(card => {
      if (card.dataset.rmStockReady) return;
      card.dataset.rmStockReady = 'true';
      const current = card.querySelector('.rmu__current');
      const sheen = card.querySelector('.rmu__sheen');
      if (!current || !sheen) return;
      const stop = () => sheen.getAnimations().forEach(animation => animation.cancel());
      const sweep = () => {
        if (reduceMotion.matches) return;
        stop();
        sheen.animate([{ transform: 'translateX(-120%)' }, { transform: 'translateX(400%)' }], { duration: 850, easing: 'ease-out', iterations: 1 });
      };
      current.addEventListener('pointerenter', sweep);
      current.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') sweep(); });
      reduceMotion.addEventListener('change', stop);
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
